import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  const renderStars = (rating: number) => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(
        <i
          key={i}
          className={`text-sm ${i < rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-300'}`}
        ></i>
      );
    }
    return stars;
  };

  return (
    <section id="comments" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-screen-2xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">观众热评</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            听听广大观众对木瓜影视的真实使用感受
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-5xl mx-auto">
          {commentItems.map((item, index) => (
            <div
              key={item.id}
              className="rounded-xl p-5 md:p-6 bg-background-100 border border-background-200/70"
              style={{ animation: `fadeInUp 0.5s ease-out ${index * 0.12}s both` }}
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-foreground-950 text-sm">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.date}</div>
                </div>
              </div>
              <div className="flex items-center gap-0.5 mb-3">{renderStars(item.rating)}</div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.content}</p>
              <div className="flex items-center gap-4 mt-4 pt-3 border-t border-background-200/70">
                <span className="text-xs text-foreground-400 flex items-center gap-1 cursor-pointer">
                  <i className="ri-thumb-up-line"></i>
                  {item.likes}
                </span>
                <span className="text-xs text-foreground-400 flex items-center gap-1 cursor-pointer">
                  <i className="ri-chat-1-line"></i>
                  回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}